module.exports = __webpack_public_path__ + "static/img/interactionLive03.e7f692e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/interactionLive03.png
// module id = uNSo
// module chunks = 0